import { useState, useEffect } from "react";
import CreamProductCard from "@/components/CreamProductCard";
import { featuredProducts } from "@/data/products";

/**
 * Featured Drops — luxury editorial layout for the cream collection.
 * Warm cream background. Gallery-style spacing.
 */
export const FeaturedDrops = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && setIsVisible(true)),
      { threshold: 0.1 }
    );
    const section = document.getElementById("featured-drops");
    if (section) observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="featured-drops"
      data-testid="featured-drops-section"
      className="section-padding bg-[#F4EFE6] relative"
    >
      <div className="container-luxury">
        <div
          className={`text-center mb-16 md:mb-24 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <p className="text-[11px] tracking-[0.4em] uppercase text-stone-500 mb-5">
            UNIXORN — MMXXV Collection
          </p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-6 text-stone-900">
            FEATURED DROPS
          </h2>
          <p className="text-base md:text-lg text-stone-600 tracking-wide max-w-2xl mx-auto">
            The cream monochrome collection. Quiet, embossed, eternal.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          {featuredProducts.map((p, idx) => (
            <div
              key={p.id}
              className={`transition-all duration-1000 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${idx * 150}ms` }}
            >
              <CreamProductCard product={p} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedDrops;
